// components/AdminOrderItemRow.tsx
import React, { useState } from 'react';
import {
  TableRow, TableCell, Dialog, DialogTitle, DialogContent, Typography, Link
} from '@mui/material';

interface OrderItem {
  id: number;
  name: string;
  quantity: number;
  price: number;
  custom_details?: string;
}

const AdminOrderItemRow: React.FC<{ item: OrderItem }> = ({ item }) => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <TableRow>
        <TableCell>
        {item.custom_details ? 
            <Link href="#" onClick={(e) => { e.preventDefault(); setModalOpen(true); }}>
                {item.name}
            </Link> : 
            item.name
        }
        </TableCell>
        <TableCell>{item.quantity}</TableCell>
        <TableCell>${item.price.toFixed(2)}</TableCell>
        <TableCell>${(item.price * item.quantity).toFixed(2)}</TableCell>
      </TableRow>

      {item.custom_details &&
        <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
            <DialogContent>
                <Typography>
                    {item.custom_details}
                </Typography>
            </DialogContent>
        </Dialog>
      }
    </>
  );
};

export default AdminOrderItemRow;
